<template>
  <header class="bg-white shadow sticky-top">
    <b-container>
      <b-navbar toggleable="xl" type="light">
        <b-navbar-brand class="p-0" to="/" @click.stop="$emit('routeClick', { name: 'Home' })">
          <div class="overflow-hidden">
            <img class="mw-100" src="@/assets/logo.svg"/>
          </div>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"/>
        <b-collapse id="nav-collapse" is-nav="is-nav">
          <b-navbar-nav class="ml-auto">
            <template v-for="route in routes" :to="route.path">
              <b-nav-item v-if="!(route.children && route.children.length)" @click="$emit('routeClick', route)" :to="route.path" active-class="active" :key="route.path" exact>
                <span v-html="$t('routes.' + route.name)"/>
              </b-nav-item>
              <b-nav-item-dropdown v-else :text="$t('routes.' + route.name)" right="right" :key="route.path" :toggle-class="{ 'active': $route.matched[0].path === route.path }">
                <b-dropdown-item v-for="childrenRoute in filteredChildren(route.children)" :key="childrenRoute.path" @click.stop="$emit('routeClick', childrenRoute)" :to="route.path + '/' + childrenRoute.path" active-class="active" exact>
                  <span v-html="$t('routes.' + childrenRoute.name)"/>
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
          </b-navbar-nav>
          <b-btn class="align-self-xl-center mr-auto mr-xl-0 ml-xl-2 mt-2 mt-xl-0" variant="outline-primary" @click="$emit('routeClick', demoRoute)" :to="demoRoute.path" size="sm" exact>
            <span v-html="$t('routes.' + demoRoute.name)"/>
          </b-btn>
        </b-collapse>
      </b-navbar>
    </b-container>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['i18n'],
  computed: {
    routes () {
      return this.$i18n.locale === 'en' ? this.$router.options.routes
        .filter(route => route.groups && route.groups.headerNav)
        .sort((a, b) => a.groups.headerNav - b.groups.headerNav)
        : this.$router.options.routes
          .filter(route => route.groups && route.groups.headerNav && !route.groups.hide)
          .sort((a, b) => a.groups.headerNav - b.groups.headerNav)
    },
    demoRoute () { return this.$router.options.routes.find(route => route.name === 'RequestDemo') }
  },
  methods: {
    filteredChildren (children) {
      return children.filter(route => route.groups && !route.groups.commingSoon)
    }
  }
}
</script>

<style lang="sass">
.navbar
  .navbar-nav
    .nav-link
      font-weight: 700
      &:focus:not(.active)
        color: #28292B
</style>



// WEBPACK FOOTER //
// src/components/ui/Header.vue